export const TID = {
  // Storefront
  navLogo: "nav-logo",
  navCart: "nav-cart-button",
  navMenuToggle: "nav-menu-toggle",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  productCard: "product-card",
  productAddBtn: "product-add-to-cart",
  productBuyBtn: "product-buy-now",
  cartDrawer: "cart-drawer",
  cartDrawerCheckout: "cart-drawer-checkout",
  emailSignupInput: "email-signup-input",
  emailSignupSubmit: "email-signup-submit",
  checkoutNext: "checkout-next",
  checkoutBack: "checkout-back",
  checkoutPlaceOrder: "checkout-place-order",
  checkoutPaymentOption: "checkout-payment-option",
  // Admin
  adminLoginEmail: "admin-login-email",
  adminLoginPassword: "admin-login-password",
  adminLoginSubmit: "admin-login-submit",
  adminSidebarLink: "admin-sidebar-link",
  adminLogout: "admin-logout",
  adminProductRow: "admin-product-row",
  adminProductNew: "admin-product-new",
  adminProductSave: "admin-product-save",
  adminProductDelete: "admin-product-delete",
  adminOrderRow: "admin-order-row",
  adminPageRow: "admin-page-row",
  adminPageNew: "admin-page-new",
  adminPageSave: "admin-page-save",
  adminSettingsSave: "admin-settings-save",
  adminCsvUpload: "admin-csv-upload",
  adminSourcingConnect: "admin-sourcing-connect",
};
